<script lang="ts">
    import AuctionDetails from './Active/AuctionDetails.svelte'
    import ProductSelection from './Active/ProductSelection.svelte'
    import ProductInfo from './Active/ProductInfo.svelte'
    import ProductVariants from './Active/ProductVariants.svelte'
    import BidButton from './BidButton.svelte'
    import ShowMessage from './Active/ShowMessage.svelte'
    import {showStore as show, sessionStore as session, buttonStore as button} from '../../stores'
    import {ShowType, ShowState} from '../../types/Show'
    import { ButtonState } from '../../types/Bids'
    import translate from '../../../../lib/translate'
    import label from './Active.translation'
</script>

<div class="auction-agent-display-show {$show.meta?.type === ShowType.MultiProduct || $show.meta?.type === ShowType.MultiCreation ? 'multishow' : ''}">
    
    <AuctionDetails />
    <ShowMessage />
    
    <ProductSelection on:productSelected /> <!-- event forwarding -->
    <ProductInfo />
    
    <div class="auction-bid-form">
        {#if $show.state === ShowState.Running}
            <ProductVariants />
        {/if}
        {#if !$session.hasBidBefore && ($button === ButtonState.placeBid || $button === ButtonState.confirmBid)}
            <div class="auction-help">
                <strong>{translate(label.auctionHelpTitle)}</strong>
                <span>{translate(label.auctionHelpStep1)}</span>
                <span>{translate(label.auctionHelpStep2)}</span>
            </div>
        {/if}
        <div class="auction-buttons">
            <BidButton on:bidButtonClick />
        </div>
    </div>
</div>